<template>
    <div class="left-0 right-0">
        <p class="text-center font-poppins text-[12px] text-[#999999]">
            Copyright © {{ currentYear }}
            <a>
                <span class="text-[#F5B134]">My</span>
                <span class="text-[#2459A8]">HappyHome</span>
            </a>
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        currentYear() {
            return new Date().getFullYear()
        }
    }
}
</script>
